import React, { useState, useEffect } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./Admin.css";

const Admin1 = () => {
  const [certificates, setCertificates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [formLoading, setFormLoading] = useState(false);

  const [formData, setFormData] = useState({
    certId: "",
    name: "",
    program: "",
    course: "",
    issueDate: "", 
    status: "",
    duration: "",
    remarks: ""
  });

  const [editId, setEditId] = useState(null);

  const API_BASE_URL = "https://www.talenttrektechnologies.com/certificate-backend";

  useEffect(() => {
    fetchCertificates();
  }, []);

  // ================= FETCH =================
  const fetchCertificates = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${API_BASE_URL}/api/certificates.php?type=new`);
      const data = await res.json();
      setCertificates(Array.isArray(data) ? data : []);
    } catch {
      toast.error("Error fetching data");
    } finally {
      setLoading(false);
    }
  };

  // ================= INPUT =================
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // ================= ADD / UPDATE =================
  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormLoading(true);

    try {
      const url = editId
        ? `${API_BASE_URL}/api/update.php`
        : `${API_BASE_URL}/api/certificates.php`;

      const body = JSON.stringify({
        id: editId || formData.certId,
        name: formData.name,
        program: formData.program,
        course: formData.course,
        issue_date: formData.issueDate,
        status: formData.status,
        duration: formData.duration,
        remarks: formData.remarks,
        type: "new"
      });

      const res = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body
      });

      const result = await res.json();

      if (result.success) {
        toast.success(editId ? "Updated" : "Added");

        setFormData({
          certId: "",
          name: "",
          program: "",
          course: "",
          issueDate: "",
          status: "",
          duration: "",
          remarks: ""
        });

        setEditId(null);
        fetchCertificates();
      } else {
        toast.error(result.message);
      }
    } catch {
      toast.error("Network error");
    } finally {
      setFormLoading(false);
    }
  };

  // ================= EDIT =================
  const handleEdit = (cert) => {
    setFormData({
      certId: cert.id,
      name: cert.name,
      program: cert.program,
      course: cert.course,
      issueDate: cert.issue_date?.split("T")[0] || "",
      status: cert.status || "",
      duration: cert.duration || "",
      remarks: cert.remarks || ""
    });
    setEditId(cert.id);
  };

  // ================= ACTIVE / DEACTIVE =================
  const toggleActive = async (cert) => {
    const newActive = cert.is_active == 1 ? 0 : 1;

    await fetch(`${API_BASE_URL}/api/update.php`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: cert.id,
        name: cert.name,
        program: cert.program,
        course: cert.course,
        issue_date: cert.issue_date,
        status: cert.status,
        duration: cert.duration,
        remarks: cert.remarks,
        is_active: newActive,
        type: "new"
      })
    });

    fetchCertificates();
  };

  return (
    <div className="admin-panel">
      <ToastContainer />
      <h1>Admin Panel - 2</h1>

      {/* ================= FORM ================= */}
      <form onSubmit={handleSubmit} className="admin-form">

        <input
          name="certId"
          placeholder="Certificate ID"
          value={formData.certId}
          onChange={handleChange}
          required
          disabled={editId !== null}
        />

        <input
          name="name"
          placeholder="Student Name"
          value={formData.name}
          onChange={handleChange}
          required
        />

        <select name="program" value={formData.program} onChange={handleChange} required>
          <option value="">Program</option>
          <option value="Internship">Internship</option>
          <option value="Training">Training</option>
          <option value="Hackathon">Hackathon</option>
  <option value="Codeathon">Codeathon</option>
  <option value="Ideathon">Ideathon</option>
        </select>

        <input
          name="course"
          placeholder="Course"
          value={formData.course}
          onChange={handleChange}
          required
        />

        <input
          type="date"
          name="issueDate"
          value={formData.issueDate}
          onChange={handleChange}
          required
        />

        {/* NEW FIELDS */}
        <select name="status" value={formData.status} onChange={handleChange} required>
          <option value="">Status</option>
          <option value="Completed">Completed</option>
          <option value="Pending">Pending</option>
        </select>

        <input
          name="duration"
          placeholder="January 8th 2026 to April 8th 2026"
          value={formData.duration}
          onChange={handleChange}
          required
        />

        <select name="remarks" value={formData.remarks} onChange={handleChange}>
          <option value="">Remarks</option>
          <option value="Excellent">Excellent</option>
          <option value="Good">Good</option>
          <option value="Satisfactory">Satisfactory</option>
        </select>

        <button type="submit">
          {formLoading ? "Processing..." : editId ? "Update" : "Add"}
        </button>
      </form>

      {/* ================= TABLE ================= */}
      {loading ? <p>Loading...</p> : (
        <table className="certificates-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Name</th>
              <th>Program</th>
              <th>Course</th>
              <th>Duration</th>
              <th>Status</th>
              <th>Remarks</th>
              <th>Active</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            {certificates.map((cert) => (
              <tr key={cert.id}>
                <td>{cert.id}</td>
                <td>{cert.name}</td>
                <td>{cert.program}</td>
                <td>{cert.course}</td>
                <td>{cert.duration}</td>

                <td style={{ color: cert.status === "Completed" ? "green" : "orange" }}>
                  {cert.status}
                </td>


                <td>{cert.remarks}</td>

               

                <td>
                  <button onClick={() => handleEdit(cert)}>Edit</button>

                  <button
                    onClick={() => toggleActive(cert)}
                    style={{
                      background: cert.is_active == 1 ? "#e74c3c" : "#27ae60",
                      color: "#fff",
                      marginLeft: "5px"
                    }}
                  >
                    {cert.is_active == 1 ? "Deactivate" : "Activate"}
                  </button>

                  {/* 🔥 DOWNLOAD FIX */}
                  <a
                    href={`${API_BASE_URL}/api/download1.php?id=${cert.id}`}
                    target="_blank"
                    rel="noreferrer"
                    style={{
                      marginLeft: "10px",
                      background: "#3498db",
                      color: "#fff",
                      padding: "6px 10px",
                      borderRadius: "5px",
                      textDecoration: "none"
                    }}
                  >
                    Download
                  </a>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default Admin1;